import { Link } from "@anoki/fse-common/dist";
import { Col } from "../Col";
import { ActionIconText, ActionIconTextProps, ArrowLink, Row } from "@/index";
import { Divider } from "../Divider";
import { ReactNode } from "react";
import "./CardBanner.scss";

type Props = {
  title: string;
  description: string | ReactNode;
  link?: Link;
  actions?: Array<ActionIconTextProps>;
  firstStatusLabel?: string;
  secondStatusLabel?: string;
  personalStatusLabel?: string;
};

export const CardBanner = ({
  actions,
  description,
  title,
  link,
  firstStatusLabel,
  secondStatusLabel,
  personalStatusLabel,
}: Props) => {
  return (
    <Col className="ui-card-banner" py="x24">
      <Row gap={"x16"} px="x24" flexWrap="wrap">
        {personalStatusLabel && (
          <div
            className={"px-x16 py-x4 bg-status-secondary rounded text-white "}
          >
            <span className={"text-white fs-7 fw-semibold fs-7"}>
              {personalStatusLabel}
            </span>
          </div>
        )}
        {firstStatusLabel && (
          <div className={"px-x16 py-x4 bg-primary rounded text-white "}>
            <span className={"text-white fs-7 fw-semibold fs-7"}>
              {firstStatusLabel}
            </span>
          </div>
        )}
        {secondStatusLabel && (
          <div className={"px-x16 py-x4 bg-status-warning rounded text-white "}>
            <span className={"text-white fs-7 fw-semibold fs-7"}>
              {secondStatusLabel}
            </span>
          </div>
        )}
      </Row>
      <Col px="x24" gap="x16">
        <h1 className="title">{title}</h1>
        <div className="description">{description}</div>
        {!!link && (
          <Row justifyContent="flex-end ">
            <ArrowLink href={link.link} isExternal={link.isExternal}>
              {link.title}
            </ArrowLink>
          </Row>
        )}
      </Col>

      {!!actions && (
        <>
          <Divider bg="border-divider" className="my-x24" />
          <Row
            justifyContent="flex-end"
            gap="x16"
            px="x24"
            flexWrap="wrap"
            className="ui-actions-wrapper"
          >
            {actions?.map((action) => (
              <ActionIconText
                classNameComponent="action-icon-text"
                {...action}
              />
            ))}
            {/* {actions?.map((action, index) => (
              <ActionIconText
                key={index}
                classNameComponent="action-icon-text"
                {...action}
              />
            ))} */}
          </Row>
        </>
      )}
    </Col>
  );
};
